import { z } from 'zod';
import { DecimalLikeSchema, IsoDateTimeSchema, PaginationSchema, UuidSchema } from './common.js';
export const ReportePeriodQuerySchema = z.object({
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
export const ReporteFinancieroSchema = z.object({
    saldoEfectivo: DecimalLikeSchema,
    saldoBanco: DecimalLikeSchema,
    totalCajas: DecimalLikeSchema,
    ingresos: DecimalLikeSchema,
    egresos: DecimalLikeSchema,
    recaudacion: DecimalLikeSchema,
});
export const ReporteRrhhSchema = z.object({
    totalCalculado: DecimalLikeSchema,
    totalPagado: DecimalLikeSchema,
    totalAdelantos: DecimalLikeSchema,
    saldoPendiente: DecimalLikeSchema,
});
export const ReporteOperacionalQuerySchema = z.object({
    venceAntes: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'invalid_date').optional(),
});
export const ReporteOperacionalSchema = z.object({
    inventarioTotal: z.number().int(),
    inventarioBajoStock: z.number().int(),
    vehiculosTotal: z.number().int(),
    gastoCombustible: DecimalLikeSchema,
    licenciasPorVencer: z.number().int(),
});
export const DashboardAlertaSchema = z.object({
    tipo: z.enum(['licencia', 'vehiculo', 'stock', 'contrato', 'factura_error']),
    mensaje: z.string(),
    cuando: z.string(),
    severidad: z.enum(['info', 'warning', 'error']),
});
export const DashboardPuntoSerieSchema = z.object({
    mes: z.string(),
    total: DecimalLikeSchema,
});
export const DashboardGastoSchema = z.object({
    categoria: z.string(),
    total: DecimalLikeSchema,
});
export const DashboardResumenSchema = z.object({
    facturacionMensual: DecimalLikeSchema,
    facturacionMesAnterior: DecimalLikeSchema,
    costoFlota: DecimalLikeSchema,
    nominaEstimada: DecimalLikeSchema,
    guardiasActivos: z.number().int(),
    contratosActivos: z.number().int(),
    licenciasPersonal: z.number().int(),
    licenciasEmpresa: z.number().int(),
    licenciasEmpresaVencidas: z.number().int(),
    evolucionFacturacion: z.array(DashboardPuntoSerieSchema),
    distribucionGastos: z.array(DashboardGastoSchema),
    alertas: z.array(DashboardAlertaSchema),
});
export const AuditLogListQuerySchema = PaginationSchema.extend({
    userId: UuidSchema.optional(),
    action: z.string().max(100).optional(),
    module: z.string().max(100).optional(),
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
//# sourceMappingURL=reportes.js.map